import {isTerminalJobStatus} from './chatJobPolling';

export function ownerRowProgress(value) {
  const keys = ['total_count', 'processed_count', 'verified_count', 'charged_count',
    'lookup_charged_count', 'uncharged_count', 'identified_owner_count', 'uncharged_owner_count', 'failed_count'];
  if (value?.version !== 1 || !keys.every((key) => Number.isSafeInteger(value[key]) && value[key] >= 0)) return null;
  if (value.total_count < 1 || value.processed_count > value.total_count
    || keys.slice(2).some((key) => value[key] > value.processed_count)
    || value.charged_count + value.uncharged_count !== value.processed_count
    || value.lookup_charged_count > value.charged_count
    || value.uncharged_owner_count > Math.min(value.identified_owner_count, value.uncharged_count)
    || value.verified_count + value.failed_count > value.processed_count) return null;
  return value;
}

export function ownerProgressPatch(job) {
  if (job?.job_type !== 'artifact_lead_enrichment') return {};
  return {ownerProgress: ownerRowProgress(job.row_progress), ownerProgressStatus: job.status || job.job_status,
    ownerJobId: job.job_id};
}

// Serial refreshes cannot race each other or overwrite the final artifact read.
export function createOwnerProgressObserver({publish, refresh, isCancelled = () => false}) {
  let closed = false;
  let requested = 0;
  let pending = Promise.resolve();
  return {
    observe(job) {
      if (closed || isCancelled() || job?.job_type !== 'artifact_lead_enrichment') return;
      const patch = ownerProgressPatch(job);
      publish(patch);
      const processed = patch.ownerProgress?.processed_count || 0;
      if (isTerminalJobStatus(job.status) || processed <= requested) return;
      requested = processed;
      pending = pending.then(async () => {
        if (closed || isCancelled()) return;
        try {
          const artifactPatch = await refresh(job.artifact_id);
          if (!closed && !isCancelled()) publish({...artifactPatch, ownerProgressRefreshError: null});
        } catch (_error) {
          requested = 0;
          if (!closed && !isCancelled()) publish({ownerProgressRefreshError:
            'Progress updated. Results will refresh when the search finishes.'});
        }
      });
    },
    async finish() {
      closed = true;
      await pending;
    },
  };
}
